<aside>
  <section>
    <library-header
      (onListModeChange)="viewTypeToggle()"
      [ngClass]="{ 'active-list-mode': viewType == 'list' }"
    ></library-header>

    <library
      [library]="library"
      [showItemMenuButtons]="showItemMenuButtons"
      [libraryType]="libraryType"
      [viewType]="viewType"
      (onScrollChanged)="onScroll()"
      [isQCAllowed]="isQCAllowed"
    ></library>
  </section>
</aside>
